
















































































































































































import { EventTypes } from '@/constants/event-type-constants';
import CallFamilyModal from '@/families/components/new/CallFamilyModal.vue';
import FamilyDataContactsModal from '@/families/components/new/FamilyDataContactsModal.vue';
import { isDoNotCallForContact } from '@/families/families-utils';
import { FamilyHubMixin } from '@/families/family-hub-mixin';
import { Contact } from '@/families/models/contact';
import { Center } from '@/organizations/locations/models/center';
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { LocaleMixin } from '@/locales/locale-mixin';
import type { Family } from '@/families/models/family';
import { DataTableHeader } from 'vuetify';
import { getManageUrl, hasManageIntegration } from '@/integrations/integration-utils';
import { getModule } from 'vuex-module-decorators';
import { InterfaceSettingsStore } from '@/dashboards/store/interface-settings-store';
import { canMakeCenterCalls } from '@/organizations/locations/center-utils';
import { SettingNames } from '@/dashboards/models/interface-settings-models';
import { getWhiteLabelColors } from '@/utils/color-utils';
import { LlmUtils } from '@/core/llm-utils';

const settingsStore = getModule(InterfaceSettingsStore);
const llmUtils = new LlmUtils();

@Component({
    components: { CallFamilyModal, FamilyDataContactsModal }
})
export default class FamilyDataContacts extends Mixins(FamilyHubMixin, LocaleMixin) {
    @Prop() readonly center!: Center | null;
    /**
     * The contacts to display in the table.
     */
    @Prop({ required: true }) contacts!: Array<Contact>;
    @Prop() family!: Family;

    private loadingKey = 'contactsInfo';
    private selectedContact: Contact | null = null;
    private showModal = false;
    private showCallModal = false;
    private updatedEvent = EventTypes.UPDATED;
    private contactUrls: Record<number, string> = {};

    async created() {
        await this.updateContactUrls();
    }

    @Watch('contacts')
    async onContactsChanged() {
        await this.updateContactUrls();
    }

    private async updateContactUrls() {
        this.contactUrls = {};
        for (const contact of this.contacts) {
            if (this.hasManageIntegration(contact)) {
                const url = await getManageUrl(contact.integrations);
                this.$set(this.contactUrls, contact.id, url);
            }
        }
    }

    /**
     * Whether calls can be made to families in this family's center.
     */
    get canMakeCenterCalls(): boolean {
        return canMakeCenterCalls(this.center);
    }

    private get hasWhiteLabel() {
        return settingsStore.hasWhiteLabel;
    }

    get manageWhiteLabelcolor() {
        getWhiteLabelColors();
        const settingsStore = getModule(InterfaceSettingsStore);
        const primaryColor = '#' + settingsStore.stored.get(SettingNames.WHITE_LABEL_PRIMARY)?.value as string;
        return primaryColor;
    }

    manageContactUrl(item: Contact) {
        return this.contactUrls[item.id] ?? llmUtils.getBaseManageUrl();
    }

    hasManageIntegration(item: Contact) {
        return hasManageIntegration(item.integrations);
    }

    /**
     * The headers for the table.
     */
    private get headers(): Array<DataTableHeader> {
        const headers = [
            { text: 'Name', value: 'name', sortable: false, width: '18%' },
            { text: 'Relationship', value: 'relation_to_child', sortable: false, width: '13%' },
            { text: 'Phone', value: 'phone.number', sortable: false, width: '120', class: 'phone' },
            { text: 'Email', value: 'email', sortable: false, width: '23%' },
            { text: 'Notes', value: 'comments', sortable: false, width: '40%' },
            { text: '', value: 'actions', sortable: false, width: '10%' }
        ];
        return headers;
    }

    /**
     * Open the modal to call the contact.
     *
     * @param contact
     */
    private callContact(contact: Contact) {
        this.selectedContact = contact;
        this.showCallModal = true;
    }

    /**
     * Whether the contact can be called.
     *
     * @param contact
     */
    isDoNotCall(contact: Contact) {
        return isDoNotCallForContact(this.family, contact);
    }

    /**
     * Open the modal to manage or add a contact.
     *
     * @param contact
     */
    private manageContact(contact: Contact | null) {
        if (!this.canEditFamily) {
            return;
        }
        this.selectedContact = contact;
        this.showModal = true;
    }

    /**
     * Reload the contacts.
     */
    private reloadData() {
        this.$emit(this.updatedEvent);
    }
}
